<template>
    <div ref="chart" style="width:100%;height:100%;">
    </div>
</template>

<script>
export default {
    name: "Bar",
    props: { wdSize: Object},
    computed: {},
    watch: {
        wdSize(n, o) {
            if (this.chart) {
                this.chart.resize();
                setTimeout(() => {
                    this.chart.resize();
                }, 10)
            }
        }
    },
    // created() {
    //
    // },
    data() {
        return {
            chart: null,
            option: {
                title: {
                    text: '客流量排行',
                    subtext: 'Ranking',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 20,
                        fontWeight: 'bold',
                    },
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        rotate: 45, // X 轴文字旋转 45 度
                        margin: 20, // 文字与轴线的距离，避免文字与 dataZoom 重叠
                    },
                    data: [],
                    //修改X轴文字颜色

                },
                yAxis: {
                    type: 'value',
                    //修改Y轴文字颜色
                    axisLabel: {
                        formatter: '{value} 条',
                        textStyle: {
                            color: "#434343",
                            margin: 15
                        },
                    },
                },
                series: [
                    {
                        data: [],
                        type: 'bar'
                    }
                ]
            },
        }
    },
    methods: {
        resize() {
            // if (this.chart) {
            this.chart.resize()
            // }
        },
        setData() {
            this.$axios({
                method: 'get',
                url: '/klph',
            }).then(r => {
                let data = r.data
                this.option.xAxis.data = data.x
                this.option.series[0].data = data.y
                this.chart.setOption(this.option)
            })

        }

    },
    mounted() {
        this.$nextTick(() => {
            this.chart = this.$echarts.init(this.$refs.chart, '');
            this.setData()
        })
    },

}
</script>

<style scoped>
</style>